<template>
  <a-card :bordered="false" :title="title">
    <a-form-model ref="ruleForm" :model="ruleForm"
                  :label-col="currentFormLayout.labelCol"
                  :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item v-if="type==0" label="标签类型" required>
        <a-radio-group v-model="radioValue">
          <a-radio :value="1">单个发送</a-radio>
          <a-radio :value="2">批量发送</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="type==1" label="人群类型" required>
        <a-radio-group v-model="crowdType" @change="changeCrowdType">
          <a-radio :value="1">用户</a-radio>
          <a-radio :value="2">分销员</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="type == 1" :label="inputName">
        <a-button type="primary" @click="showModal">{{ buttonText }}</a-button>
      </a-form-model-item>
      <a-form-model-item v-if="type == 1" :wrapper-col="currentFormLayout.offsetCol">
        <div class="tag-list">
          <div class="tag-box" v-for="(item,index) in tagList" :key="index">
            <span class="tag-name">{{ item.name }}</span>
            <a-icon class="close" type="close" @click="deleteTag(item)"/>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item v-if="type == 2" :wrapper-col="currentFormLayout.offsetCol">
        向近30天新增且无成交订单记录的用户发送营销内容
      </a-form-model-item>
      <a-form-model-item v-if="type == 2" label="定时发送时间">
        <a-time-picker
          use24-hours
          format="HH:mm"
          :disabledHours="getDisabledHours"
          :disabledMinutes="getDisabledMinutes"
          @change="onChange"
        />
      </a-form-model-item>
      <a-form-model-item label="选择模板" required>
        <a-select v-model="ruleForm.templateId" @change="onTemplateChange" style="max-width:400px;">
          <a-select-option v-for="item in modelList" :key="item.templateId"
                           :value="item.templateId">
            {{ item.templateTitle }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="ruleForm.templateId==-100" label="短信内容">
        <a-textarea :maxLength="250" v-model="ruleForm.smsText" placeholder="请输入短信内容" :rows="10"/>
      </a-form-model-item>
      <div v-if="ruleForm.templateId!==-100">
        <a-form-model-item required label="短信内容">{{ templateInfo.templateContent }}</a-form-model-item>
        <a-form-model-item required v-for="(item,index) in templateInfo.templateWords" :key="index" :label="item.name">
          <a-input v-model="item.value" :placeholder="getTemplateTips(item.name)" :maxLength="20"></a-input>
        </a-form-model-item>
      </div>
      <a-form-model-item v-if="type == 1" label="预估效果">
        {{ phoneLength }}人符合条件
      </a-form-model-item>
      <a-form-model-item v-if="radioValue == 1&&type==0" label="接收手机号">
        <a-input v-model="ruleForm.mobilePhoneNumber" placeholder="请输入手机号" :maxLength="11"></a-input>
      </a-form-model-item>
      <a-form-model-item v-if="type !== 0" label="测试手机号">
        <a-input v-model="testPhone" placeholder="请输入手机号" :maxLength="11"></a-input>
      </a-form-model-item>
      <!-- extra="只能上传excel文件，且不超过10M" -->
      <a-form-model-item v-if="radioValue !== 1&&type==0" label="接收手机号">
        <a-textarea :disabled="fileList && fileList.length > 0" v-model="ruleForm.mobilePhoneText"
                    placeholder="请输入手机号(一行一个)"
                    :rows="8"/>
        <div class="upload-box">
          <a-upload
            name="file"
            ref="upload"
            :fileList="fileList"
            :multiple="false"
            :beforeUpload="beforeUpload"
            :remove="handleRemove"
          >
            <a-button type="primary">选取附件</a-button>
          </a-upload>
          <a-button class="download-btns" icon="download" @click="downloadTemplateFile">下载手机号模板
          </a-button
          >
        </div>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button v-if="type==0" @click="handleSubmit" :loading="submitLoading" type="primary">确认发送</a-button>
        <a-button v-else-if="type==1" @click="sendCrowdSms" :loading="submitLoading" type="primary">确认发送</a-button>
        <a-button v-else @click="sendDelaySms" :loading="submitLoading" type="primary">确认发送</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="buttonText" :width="600" :footer="null" :visible="visible" @cancel="handleCancel">
      <search-page-view
        :col="3"
        ref="pageList"
        :columns="crowdType==1?columns1:columns2"
        :queryParams="queryParams"
        row-key="id"
        :enableSearch="false"
        :requestPromise="loadPromise"
      >
        <a-form-item slot="operation">
          <a-input-search placeholder="请输入分组名称" @search="onSearch" style="max-width: 200px;"/>
        </a-form-item>
        <a slot="action" slot-scope="rowItem" @click="addList(rowItem.record)">选择</a>
      </search-page-view>
    </a-modal>
  </a-card>
</template>

<script>
import userHelper from '../../../utils/helper/userHelper'
import { Base64 } from 'js-base64'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import importSheetHelper from '@/utils/helper/importSheetHelper'

export default {
  name: 'SendSmsMsg',
  mixins: [ruleFormMixins],
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getRequest(params),
      type: this.$route.query.type,
      title: this.$route.query.type == 0 ? '自定义手机号发送' : this.$route.query.type == 1 ? '按人群发送' : '新客转化',
      submitLoading: false,
      uploadFileUrl: this.getAppConfig().smsUrl + 'sms/sendManySms', //文件上传地址
      radioValue: 1,
      templateId: -100,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      modelList: [],
      ruleForm: {
        templateId: -100,//模版id 为-100是自定义
        mobilePhoneNumber: '',////手机号码。单发时使用
        mobilePhoneText: '',//手机号码。批量时使用
        smsText: ''
      },
      submitData: {
        merchantId: '',
        phones: '',
        platformId: '',
        smsContent: '',
        templeTitle: ''
      },
      fileList: [],
      mobilePhoneNumberText: '',
      templateContent: '',
      templateInfo: {//当前选中的模版内容
        templateWords: [],//
        templateId: '',
        templateTitle: '',
        templateContent: ''
      },
      sendTime: '',
      phones: '',
      testPhone: '',
      crowdType: 1,
      inputName: '用户标签',
      buttonText: '选择标签',
      tagList: [],
      tagIdList: [],
      visible: false,
      columns1: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '标签名称',
          dataIndex: 'name'
        },
        // {
        //   title: '用户数量',
        //   dataIndex: 'personNumber'
        // },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columns2: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        // {
        //   title: '成员数量',
        //   dataIndex: 'staffCount'
        // },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      phonesList: '',
      phoneLength: 0
    }
  },
  mounted() {
    this.getModelList()
    if (this.type == 2) {
      this.getMemberNoOrderInDays()
    }
    if (this.type == 1) {
      this.getTagMemberMobile()
    }
  },
  methods: {
    addList(item) {
      let tagList = {
        id: item.id,
        name: item.name
      }
      if (!this.tagIdList.includes(item.id)) {
        this.tagIdList.push(item.id)
        this.tagList.push(tagList)
        this.getTagMemberMobile()
        this.visible = false
      } else {
        this.$message.error('请不要添加重复内容')
      }
    },
    onSearch(value) {
      this.queryParams.name = value
      this.$refs.pageList.refresh(true)
    },
    getTagMemberMobile() {
      let param = {
        merchantId: this.merchantId,
        type: this.crowdType,
        tagIdList: this.tagIdList
      }
      this.getHttpServices().getUserService().post('api/v2/statistics/getTagMemberMobile', param)
        .then(res => {
          this.phonesList = res
          this.phoneLength = res ? res.split(',').length : 0
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRequest(params) {
      if (this.crowdType == 1) {
        let param = {
          pageNum: params.limitDto.pageNum,
          pageSize: params.limitDto.pageSize,
          name: this.queryParams.name
        }
        return this.getHttpServices().getUserService().get('api/v2/member/tag/list', param)
      } else {
        return this.getHttpServices().getUserService().post('merchant/v2/group/getGroupList', params)
      }
    },
    deleteTag(item) {
      let idList = this.tagIdList.filter(tag => tag !== item.id)
      let list = this.tagList.filter(tag => tag !== item)
      this.tagIdList = idList
      this.tagList = list
      this.getTagMemberMobile()
    },
    showModal() {
      this.visible = true
      this.$nextTick(
        () => this.$refs.pageList.refresh(true)
      )
    },
    handleCancel() {
      this.visible = false
    },
    changeCrowdType(e) {
      this.tagList = []
      this.tagIdList = []
      this.queryParams.name = ''
      let type = e.target.value
      this.inputName = type == 1 ? '用户标签' : '成员分组'
      this.buttonText = type == 1 ? '选择标签' : '选择分组'
      this.getTagMemberMobile()
    },
    getMemberNoOrderInDays() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMemberNoOrderInDays?merchantId=' + this.merchantId)
        .then(res => {
          this.phones = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onChange(time, timeString) {
      var myDate = new Date()
      let DateTime = myDate.toLocaleDateString().split('/').join('-') + ' ' + timeString
      this.sendTime = DateTime
    },
    sendCrowdSms() {
      let smsContent = this.ruleForm.templateId === -100 ? this.ruleForm.smsText : this.getTemplateMessage()
      if (!smsContent) {
        this.$message.error('请输入短信内容')
        return
      }
      if (!this.phoneLength && !this.testPhone) {
        this.$message.error('无人符合发送条件')
        return
      }
      this.submitLoading = true
      let param = {
        phones: this.phonesList ? this.phonesList : '',
        smsContent: Base64.encode(smsContent),
        templeTitle: this.ruleForm.templateId === -100 ? '' : this.templateInfo.templateTitle,
        platformId: this.platformId,
        merchantId: this.merchantId,
        testPhone: this.testPhone,
        ...this.getEncryptInfo()
      }
      this.getHttpServices().getSmsApiService().post('sms/sendCrowdSms', param)
        .then(res => {
          this.$message.success('发送成功')
          setTimeout(() => {
            this.submitLoading = false
          }, 1000)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        setTimeout(() => {
          this.submitLoading = false
        }, 1000)
      })
    },
    sendDelaySms() {
      let smsContent = this.ruleForm.templateId === -100 ? this.ruleForm.smsText : this.getTemplateMessage()
      if (!smsContent) {
        this.$message.error('请输入短信内容')
        return
      }
      let param = {
        phones: this.phones,
        smsContent: Base64.encode(smsContent),
        templeTitle: this.ruleForm.templateId === -100 ? '' : this.templateInfo.templateTitle,
        platformId: this.platformId,
        merchantId: this.merchantId,
        testPhone: this.testPhone,
        sendTime: this.sendTime,
        ...this.getEncryptInfo()
      }
      this.getHttpServices().getSmsApiService().post('sms/sendDelaySms', param)
        .then(res => {
          this.$message.success('发送成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getDisabledHours() {
      var myDate = new Date()
      var hours = []
      for (var i = 0; i < myDate.getHours(); i++) {
        hours.push(i)
      }
      return hours
    },
    getDisabledMinutes(selectedHour) {
      var myDate = new Date()
      var minutes = []
      if (selectedHour === myDate.getHours()) {
        for (var i = 0; i < myDate.getMinutes(); i++) {
          minutes.push(i)
        }
      }
      return minutes
    },
    handleSubmit() {
      if (this.radioValue == 1) {
        this.sendSingleSms()
      } else {
        this.sendManySms()
      }
    },
    isPhoneNumber(phone) {
      //手机号正则
      let r = /^1[3456789]\d{9}$/
      return r.test(phone)
    },
    //单发送短信
    sendSingleSms() {
      let smsContent = this.ruleForm.templateId === -100 ? this.ruleForm.smsText : this.getTemplateMessage()
      if (!smsContent) {
        if (this.ruleForm.templateId === -100) {
          this.$message.error('请输入短信内容')
        }
        return
      }
      if (!this.ruleForm.mobilePhoneNumber) {
        this.$message.error('请输入要接收的手机号码')
        return
      }
      if (!this.isPhoneNumber(this.ruleForm.mobilePhoneNumber)) {
        this.$message.error('输入的手机号码不正确')
        return
      }
      this.submitLoading = true
      this.getHttpServices().getSmsApiService().post('sms/sendSingleSms', {
        merchantId: this.merchantId,
        platformId: this.platformId,
        phones: this.ruleForm.mobilePhoneNumber,
        smsContent: smsContent,
        templeTitle: this.ruleForm.templateId === -100 ? '' : this.templateInfo.templateTitle,
        ...this.getEncryptInfo()
      }).then(res => {
        this.$message.success('发送成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //批量发送短信
    sendManySms() {
      let smsContent = this.ruleForm.templateId === -100 ? this.ruleForm.smsText : this.getTemplateMessage()
      this.getLogUtils().logWithTag(' sendSingleSms', smsContent)
      if (!smsContent) {
        if (this.ruleForm.templateId === -100) {
          this.$message.error('请输入短信内容')
        }
        return
      }
      const phoneText = this.ruleForm.mobilePhoneText
      if (!phoneText && this.fileList.length === 0) {
        this.$message.error('请输入接收手机号码或添加附件文件')
        return
      }
      if (this.fileList.length > 0) {
        //发送文件
        //从文件获取手机号列表
        importSheetHelper.getSheetDataListFromFile(this.fileList[0], '手机号')
          .then(phoneList => {
            if (phoneList.length > 0) {
              this.sendManySmsRequest(phoneList, smsContent)
            } else {
              this.$message.error('手机文件解析失败,请按对照模板填写手机号')
            }
          }).catch(reason => this.$message.error('手机文件解析失败'))
      } else if (phoneText) {
        const phoneList = phoneText.split('\n')
        this.sendManySmsRequest(phoneList, smsContent)
      }
    },
    //发送短信请求
    sendManySmsRequest(phoneList, smsContent) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        phones: '',
        smsContent: Base64.encode(smsContent),//表单提交，需要对特殊字符做处理
        templeTitle: this.templateId === -100 ? '' : this.templateInfo.templateTitle,
        ...this.getEncryptInfo()
      }
      params.phones = phoneList.join(',')
      //这里要提交表单 ,要进行拼接参数
      let paramsStr = ''
      for (let key in params) {
        if (paramsStr.length > 0) {
          paramsStr = paramsStr + '&'
        }
        paramsStr = paramsStr + key + '=' + params[key]
      }
      let headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
      this.getHttpServices().getSmsApiService().post('sms/sendManySms', paramsStr, headers)
        .then(res => {
          this.$message.success('发送成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取模版数据
    getTemplateMessage() {
      const templateWords = this.templateInfo.templateWords
      let content = this.templateInfo.templateContent
      for (let i = 0, len = templateWords.length; i < len; i++) {
        if (templateWords[i].value) {
          content = content.replace(templateWords[i].key, templateWords[i].value)
        } else {
          this.$message.error('请输入' + templateWords[i].name.replace('：', ''))
          return ''
        }
      }
      return content
    },
    //获取模版内容
    getTemplateContent(id) {
      let url = 'template/getTemplateContent/' + id
      this.getHttpServices()
        .getSmsApiService()
        .get(url)
        .then(res => {
          this.templateContent = res.templateContent
          var regular = /([{]([\u4e00-\u9fa5]||[A-Za-z0-9])*[}])/g
          var keys = this.templateContent.match(regular)
          if (keys && keys.length > 0) {
            this.currentTemplateKeys = keys.map((item, index, arr) => {
              return item.replace('{', '').replace('}', '')
            })
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取加密信息
    getEncryptInfo() {
      const currentTime = new Date().getTime()
      const text = currentTime + 'smsJiaMi' + currentTime
      return {
        sign: userHelper.md5(text),
        encryptInfo: currentTime
      }
    },
    isPhone(value) {
      if (value) {
        return /^1[3456789]\d{9}$/.test(value)
      }
      return false
    },
    beforeUpload(file) {
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = extensionsName === 'xls'
      const extension2 = extensionsName === 'xlsx'
      if (!extension && !extension2) {
        this.$message.error('上传文件只能是 xls、xlsx格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      this.fileList = [file]
      return false
    },
    //获取发送模板列表
    getModelList() {
      this.getHttpServices().getSmsApiService().post('template/getTemplateInfoList', {
        merchantId: this.merchantId,
        platformId: this.platformId
      }).then(res => {
        let templateList = []
        let customItem = { templateId: -100, templateTitle: '自定义' }
        templateList.push(customItem)
        templateList.push(...res)
        this.modelList = templateList
        this.getLogUtils().logWithTag('==this.modelList==', this.modelList)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handlePhone(rule, value, callback) {
      if (value) {
        if (this.isPhone(value)) {
          callback()
        } else {
          callback(new Error('请输入正确手机号码'))
        }
      }
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })
      this.fileList = fileList
      this.getLogUtils().logWithTag('handleChange', this.fileList)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.getLogUtils().logWithTag('附件删除成功', this.fileList)
    },
    downloadTemplateFile() {
      window.open('https://imgb.woyoubooking.com/config/template.xlsx')
    },
    //短信模版变更监听
    onTemplateChange(id) {
      this.getLogUtils().logWithTag('onTemplateChange', id)
      if (id !== -100) {
        const list = this.modelList
        for (let i = 0, len = list.length; i < len; i++) {
          if (id === list[i].templateId) {
            let content = list[i].templateContent
            let regular = /([{]([\u4e00-\u9fa5]||[A-Za-z0-9])*[}])/g
            const keys = content.match(regular)
            const words = []
            if (keys) {
              for (let j = 0, kLen = keys.length; j < kLen; j++) {
                words.push({ key: keys[j], name: this.getTemplateWordName(keys[j]), value: '' })
              }
            }
            this.templateInfo = {
              templateWords: words,
              templateId: id,
              templateTitle: list[i].templateTitle,
              templateContent: content
            }
            break
          }
        }
      } else {
        this.templateInfo = { templateWords: [], templateContent: '', templateId: id }
      }
      this.getLogUtils().logWithTag('==this.templateInfo==', this.templateInfo)
    },
    getTemplateTips(name) {
      return ('请输入' + name).replace('：', '')
    },
    getTemplateWordName(name) {
      if (name) {
        let targetName = name.replace('{', '')
        return targetName.replace('}', '') + '：'
      }
      return name
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');

.upload-box {
  position: relative;
  margin-top: 15px;

  .download-btns {
    position: absolute;
    top: 0;
    left: 200px;
  }
}

.tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 400px;

  .tag-box {
    display: flex;
    align-items: center;
    width: 80px;
    height: 30px;
    padding: 0 4px;
    border-radius: 4px;
    border: 1px solid #e9e9e9;
    margin-right: 10px;
    margin-bottom: 10px;

    .tag-name {
      text-align: center;
      width: 60px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>